import React, { Component, Fragment } from "react"
import { Link }             from "react-router-dom"
import { withRouter }       from "react-router"
import shop from "shop/shop"
import { Button, Message,Table,Icon } from "semantic-ui-react"
import CartTotal from "components/Cart/CartTotal"
import queryString from "qs"
import {Checkbox, Col, Form, FormField, Row} from "elemental-react16"
import Price from "components/Price/Price"
import { act } from "react"
import Responsive from "react-responsive"

@withRouter
class FooterCheckout extends Component {

  state = {
    agb: false,
    privacy: false,
  }

  componentDidMount() {
    shop.cart.hydrate()
  }


    handleEnquiry = () => {
      shop.cart.setExtra( "is_quotation_request", true )
      this.props.history.push( "../success/" )
    }
  
    handleSubmit = async () => {
  
      shop.cart.setExtra( "is_quotation_request", false )
      let couponsActivated = shop.cart.activeCoupons && shop.cart.activeCoupons[0]
      if(couponsActivated){
        await shop.cart.setExtra( "couponUsed", true )
        await shop.cart.setExtra( "netto", Number((shop.cart.brutto) - Number(shop.cart.tax)) )
        await shop.cart.setExtra( "tax", shop.cart.tax )
        await shop.cart.setExtra( "brutto", shop.cart.brutto )
      }
      this.props.history.push( "../success/" )
    }
  
    handleAgb = ( agb ) => {
      console.log( `agb`, agb )
      this.setState( {agb} )
    }
  
    handleDatenschutz( privacy ) {
      this.setState( {privacy} )
    }

	render() {
		const { isRequest, activeStep, order} = this.props
    let {agb, privacy,fracht} = this.state
    const canOrder = !agb || shop.cart.sum <= shop.config.MIN_ORDER_VALUE || !privacy
    const { referer = "/", ...query } = queryString.parse( location.search, { ignoreQueryPrefix: true } )
		console.log("WHOAMI FOOTERCHECKOUT: ",activeStep, this.props, referer, shop.session ? shop.session.value : "no session")
		return (<React.Fragment>
              <section>

          <div className={`${activeStep !== 3 ?  "container pt4" : "pt4"}`}>
                      <div className="pr2">
                        <div className="fr">
                          {activeStep !== 3 && activeStep !== 10 ? <CartTotal activeStep={activeStep} sum={shop.cart.sum} size={shop.cart.size}/> : activeStep == 10 ? <CartTotal activeStep={activeStep} sum={Number(order.netto)} size={order.positions.length}/> : <CartTotal activeStep={activeStep} sum={Number(order.netto)} size={order.positions.length}/>}
                        </div>
                      </div>
            </div>
            {activeStep == 2 && <div className="container pt3">
              <div className="tr pr2">
                              <Form type="horizontal">

                  <FormField>

                    {!privacy && <div className="cf dib pb2">
                      <Message negative className="">
                        <div className="total ">
                          <div className="ph3">
                            <Icon name="info" />{translate( "please confirm our privacy information" )}
                          </div>
                        </div>
                      </Message>
                    </div>}

                    <div className="tr"><Link target="_blank"
                                  to="/cms/datenschutzerklaerung/">{translate( "Datenschutzerklärung" )}</Link><br />
                    </div>
                    <Checkbox value={privacy}
                          onChange={( e ) => this.handleDatenschutz( e.target.checked )}
                          label={translate( "privacy_notice_notice" )} />
                  </FormField>



                  <FormField>
                    {!agb && <div className="cf dib pb2">
                      <Message negative className="">
                        <div className="total ">
                          <div className="ph3">
                            <Icon name="info" />{translate( "please confirm our general terms" )}
                          </div>
                        </div>
                      </Message>
                    </div>}

                    <div className="tr"><Link target="_blank"
                                  to="/cms/agb/">{translate( "AGB" )}</Link><br /></div>
                    <Checkbox value={agb} onChange={( e ) => this.handleAgb( e.target.checked )}
                          label={translate( "I accept the general terms and conditions" )} />
                  </FormField>
                </Form>
            </div>
            </div>}
        </section>
      <Responsive minWidth={768}>
        <section className="mb4 ">
          <div className={`${activeStep !== 3 ?  "container" : ""}`}>
              <Table className="productTableCheckoutContinue"  compact>
                <tbody>
                  <tr>
                              <td className="tl">
                              <div className="" >
                                <table>
                                  <colgroup>
                                    <col width="50%"/>
                                    <col width="50%"/>
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <td colSpan="2" className="pt3">
                                        <div className="pb3" >
                                          <Link className={"logo"} to="/home/">
                                            <img  style={{height: "50px", width: "450px"}}
                                              src={shop.config.logo}
                                              alt="" />
                                          </Link>
                                          </div>
                                      <p className="f4 fw7">{activeStep == 10 ? translate("Sie haben Fragen zu Ihrer Bestellung?"): translate("cartfooter.helphint")}</p>
                                      </td>
                                      </tr>
                                    <tr>
                                      <td className="pt3">
                                        <a href={`tel:+4959197778649`}><span className="f5 fw5" style={{ color: "#a2cf66", backgroundColor: "transparent" }}><Icon
                                                  name={"phone"} />+49 (0) 591 - 97 77 86 49</span></a>
                                        </td>
                                      <td className="pt3">
                                        <a href={`mailto:vertrieb@trend-soft.de?subject=Anfrage bezüglich des Bestellvorgangs, Kunde #${shop.session ? shop.session.value.map_id : ""}`}>
                                          <span className="f5 fw5" style={{ color: "#a2cf66", backgroundColor: "transparent" }}><Icon
                                        name={"mail"} />vertrieb@trend-soft.de</span></a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                </div>
                                </td>     
                    <td className="pb3 ">
                      <div className="flex flex-row justify-end ">

                        <table>
                          <tbody>
                            { activeStep <= 2 && <Fragment><tr>
                              <td className="pt4">
                              <Link to={{
                                  pathname: activeStep === 0 ? "/checkout/delivery"  : activeStep === 1 ? "/checkout/confirmation" : undefined,
                                  search  : this.props.location.search
                                }}>
                                  <Button onClick={() => {
                                    if(activeStep === 2) {
                                      this.handleSubmit()
                                    }
                                  }}
                                    loading={false} disabled={activeStep == 2 ? canOrder : false}
                                    primary style={{borderRadius: "35px", height: "50px", width: "380px"}} className="ml3 pl3">
                                    {activeStep === 0 || activeStep === 1 ? translate( "Weiter" ) : translate( "Bestellung abschicken" )}
                                    <i className="icon-angle-right"/>
                                  </Button>
                                </Link>
                              </td>
                            </tr>
                            {/*                            <tr>
                              {activeStep == 2 && <td>
                                <Link to={{
                                  pathname: undefined,
                                  search  : this.props.location.search
                                }}>
                                  <Button onClick={() => {
                                    if(activeStep === 2) {
                                      this.handleEnquiry()
                                    }
                                  }}
                                    loading={false} disabled={activeStep == 2 ? canOrder : false}
                                    primary style={{borderRadius: "35px", height: "50px", width: "380px"}} className="ml3 pl3">
                                    {translate( "Anfrage stellen" )}
                                    <i className="icon-angle-right"/>
                                  </Button>
                                </Link>
                              </td>}
                            </tr> */}</Fragment>}
                            <tr>
                              <td>
                                {activeStep === 100 && <Fragment>
                                  <Link to="/"> <Button style={{width: "200px", borderRadius: "35px", height: "50px"}} basic> <i className="icon-angle-left"  />{translate( "zurück zur Startseite" )}</Button></Link>
                                  <Link to="/checkout"> <Button style={{width: "200px", borderRadius: "35px", height: "50px"}} primary>{translate( "zum Warenkorb" )}<i className="icon-angle-right" /> </Button></Link>
                                </Fragment>}
                                {activeStep === 0 && 
                                <Link className={""} to={referer}>
                                <Button style={{borderRadius: "35px", height: "50px", width: "380px"}} className="ml3 pl3">
                                  <i className="icon-angle-left"/>
                                  {translate( "Zurück" )}
                                </Button>
                              </Link>}
                              {activeStep != 0 && activeStep !== 10 && activeStep !== 100 && <Link className={""} to={{
                                  pathname: activeStep === 0 ? referer  : activeStep === 1 ? "/checkout" : activeStep == 2 ? "/checkout/delivery" : activeStep == 3 ? "/home" : undefined,
                                  search  : this.props.location.search
                                }}>
                                <Button style={{borderRadius: "35px", height: "50px", width: "380px"}} className="ml3 pl3">
                                  <i className="icon-angle-left"/>
                                  {translate( "Zurück" )}
                                </Button>
                              </Link>}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>

                    </td>
                  </tr>
                </tbody>
              </Table>
              </div>
          {activeStep == 3 && <div className="">
          <p className="b"> {translate( "confirmation.notice" )}</p>
          <p>{translate("Der Gesamtpreis netto kann sich bei der Rechnungsstellung durch Lieferkosten noch ändern.")}</p>
        </div>}
        </section>
        </Responsive>
      <Responsive maxWidth={767}><div className="pt4">
                        <div className="flex flex-row items-center justify-center">
                          <table>
                          <tbody>
                            { activeStep <= 2 && <Fragment><tr>
                              <td className="pt4 pb3">
                              <Link to={{
                                  pathname: activeStep === 0 ? "/checkout/delivery"  : activeStep === 1 ? "/checkout/confirmation" : undefined,
                                  search  : this.props.location.search
                                }}>
                                  <Button onClick={() => {
                                    if(activeStep === 2) {
                                      this.handleSubmit()
                                    }
                                  }}
                                    loading={false} disabled={activeStep == 2 ? canOrder : false}
                                    primary style={{borderRadius: "35px", height: "50px", width: "430px"}} className="ml3 pl3">
                                    {activeStep === 0 || activeStep === 1 ? translate( "Weiter" ) : translate( "Bestellung abschicken" )}
                                    <i className="icon-angle-right"/>
                                  </Button>
                                </Link>
                              </td>
                            </tr></Fragment>}
                            <tr>
                              <td>
                                {activeStep === 100 && <Fragment>
                                  <Link to="/"> <Button style={{width: "200px", borderRadius: "35px", height: "50px"}} basic> <i className="icon-angle-left"  />{translate( "zurück zur Startseite" )}</Button></Link>
                                  <Link to="/checkout"> <Button style={{width: "200px", borderRadius: "35px", height: "50px"}} primary>{translate( "zum Warenkorb" )}<i className="icon-angle-right" /> </Button></Link>
                                </Fragment>}
                                {activeStep === 0 && 
                                <Link className={""} to={referer}>
                                <Button style={{borderRadius: "35px", height: "50px", width: "430px"}} className="ml3 pl3">
                                  <i className="icon-angle-left"/>
                                  {translate( "Zurück" )}
                                </Button>
                              </Link>}
                              {activeStep != 0 && activeStep !== 10 && activeStep !== 100 && <Link className={""} to={{
                                  pathname: activeStep === 0 ? referer  : activeStep === 1 ? "/checkout" : activeStep == 2 ? "/checkout/delivery" : activeStep == 3 ? "/home" : undefined,
                                  search  : this.props.location.search
                                }}>
                                <Button style={{borderRadius: "35px", height: "50px", width: "430px"}} className="ml3 pl3">
                                  <i className="icon-angle-left"/>
                                  {translate( "Zurück" )}
                                </Button>
                              </Link>}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                          </div>
                          <div className="pl2 mt4 flex flex-column items-center">
                            <table className="">
                            <colgroup>
                                <col width="30%"/>
                                <col width="70%"/>
                              </colgroup>
                              <tbody>
                                <tr className=" pt2 pb2">       
                                    <td rowSpan={3} colSpan="3" className="tc pt4 pa2">
                                      <div className="pt3 pb3 pl2 pr2">
                                        <Link className={"logo"} to="/home/">
                                      <img
                                        src={shop.config.logo}
                                        alt="" />
                                    </Link></div>
                                    <p className="pa2 tl f4 fw7">{activeStep == 10 ? translate("Sie haben Fragen zu Ihrer Bestellung?"): translate("Sie benötigen Hilfe bei Ihrer Bestellung?")}</p>
                                    <div className="flex flex-row justify-start"><a className="pl3 pr2 pb2" href={`tel:+4959197778649`}><span className="f6 fw5" style={{ color: "#a2cf66", backgroundColor: "transparent" }}><Icon
                                                name={"phone"} />+49 (0) 591 - 97 77 86 49</span></a>
                                      <a className="pl2 pr2 pb2" href={`mailto:vertrieb@trend-soft.de?subject=Anfrage bezüglich des Bestellvorgangs, Kunde #${shop.session.value.map_id}`}>
                                        <span className="f6 fw5" style={{ color: "#a2cf66", backgroundColor: "transparent" }}><Icon
                                      name={"mail"} />vertrieb@trend-soft.de</span></a>
                                      </div>
                                    </td>
                                  </tr>
                              </tbody>
                          </table>
                          </div>
                          </div>

        </Responsive>

        </React.Fragment>
		)
	}
}

export default FooterCheckout



// WEBPACK FOOTER //
// ./src/theme/demo2025/pages/checkout/FooterCheckout.js